<template>
    <div id="main">
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('criticas-despesas') }} - {{ this.usr.nome }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a>{{ $t('despesas') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'des-critica-despesa' })">{{
                                        $t('criticas-despesas')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('empresa-invalida') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            @click="$router.push({ name: 'des-critica-despesa' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button class="save-btn" type="button" tag="button" @click="salvar">
                            {{ $t('vincular') }}
                        </button>
                    </div>
                </div>

                <br />
                <div class="columns">
                    <div class="column is-12">
                        <vss-select
                            ref="empresaSelect"
                            label="nome"
                            placeholder="selecione"
                            v-model="empresaSelecionada"
                            title="vincular-a-empresa"
                            :options="empresas"
                            @search="carregarEmpresas"
                            searchable
                            :invalid="empresaSelecionada == null"
                        />
                    </div>
                </div>

                <div class="registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        :data="despesasSemEmpresa"
                        class="data-table"
                        hoverable
                        responsive
                        :checkable="true"
                        :checked-rows.sync="despesasSemEmpresaSelecionadas"
                    >
                        <b-table-column
                            v-for="f in fields"
                            :key="f.key + '-' + f.nome"
                            :field="f.key"
                            :label="$t(f.key)"
                            :width="f.width"
                            :sortable="f.sortable"
                            v-slot="props"
                        >
                            <span v-if="f.key == 'data'">
                                {{ props.row.datahora | moment('L LT') }}
                            </span>
                            <span v-else-if="f.key == 'motivo-despesa'">
                                {{ props.row.descricaodespesa }}
                            </span>
                            <span v-else-if="f.key == 'valor'">
                                {{ getDecimal(props.row.valor, null, true) }}
                            </span>
                        </b-table-column>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CriticasDespesasService from '@/services/despesas/CriticasDespesasService';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService';
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import Message from '@/models/Message';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            service: new CriticasDespesasService(this.$http, this.$router),
            serviceUsuario: new GerenciarUsuariosService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            fields: [
                { key: 'motivo-despesa', width: null, sortable: false, sortFn: null },
                {
                    key: 'valor',
                    width: null,
                    centered: true,
                    vcenter: true,
                    sortable: false,
                    sortFn: null,
                },
                { key: 'data', width: null, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            empresas: [],
            despesasSemEmpresa: [],
            despesasSemEmpresaSelecionadas: [],
            debouncedOnSearch: null,
            empresaSelecionada: null,
            delete: null,
            queryFilter: '',
            column: 'colaborador',
            order: 'asc',
            permissao: {},
            msgs: [],
            usr: {
                nome: null,
            },
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'despesas',
            'criticas-despesas',
            'criticas-despesas'
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'criticas-despesas' },
            });
        } else {
            this.carregarUsuario(this.$route.params.usuarioid);
            this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        carregarUsuario(id) {
            this.isLoading = true;
            this.serviceUsuario
                .findById(id)
                .then((usuario) => {
                    this.usr = usuario.content;
                })
                .finally((_) => {
                    this.carregarDados();
                });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        salvar() {
            if (this.empresaSelecionada != null) {
                if (this.despesasSemEmpresaSelecionadas.length > 0) {
                    let idsDespesas = this.despesasSemEmpresaSelecionadas.map(
                        (item) => item.iddespesa
                    );
                    this.service
                        .corrigeEmpresa(idsDespesas, this.empresaSelecionada.idempresa)
                        .then((body) => {
                            if (body.status == 200) {
                                this.msgs.push(new Message('success', body.message, true));
                                setTimeout(() => {
                                    this.$router.push({
                                        name: 'des-critica-despesa',
                                    });
                                }, 2000);
                            } else {
                                if (this.$t(body.message)) {
                                    this.msgs.push(new Message('alert', body.message, true));
                                } else {
                                    this.msgs.push(
                                        new Message('error', 'msg-problema-realizar-acao', true)
                                    );
                                }
                            }
                            this.isSaving = false;
                        });
                } else {
                    this.msgs.push(new Message('alert', 'selecione-uma-motivo', true));
                }
            } else {
                this.$refs.empresaSelect.focusedOut = true;
                this.msgs.push(new Message('alert', 'selecione-uma-empresa', true));
            }
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        decimalPlaces(n) {
            let places = typeof n != 'number' ? 2 : n > 8 ? 8 : n < 0 ? 0 : n;
            return {
                minimumFractionDigits: places,
                maximumFractionDigits: places,
            };
        },
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[TURNO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[TURNO] Mensagem: ${r.message}`);
                    } else {
                        this.empresas = r.content;
                    }
                })
                .catch((e) => {
                    console.error('[TURNO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresasLoading = false;
                });
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAllDespesasSemEmpresa(this.usr.id)
                .then((value) => {
                    this.despesasSemEmpresa = value.content;
                    this.isEmpty = this.despesasSemEmpresa.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os acertos.');
                })
                .finally(() => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = body.content.map((m) => {
                return {
                    id: m.usuario.idusuario,
                    colaborador: m.usuario.nome,
                    data: m.checkindatahora,
                    motivoCritica: m.motivoCritica,
                };
            });
            return list;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;
    }

    .position-button {
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .size-select {
        height: 40px;
    }

    .size {
        margin-top: 5px;
        height: 37px;
    }

    .align-right {
        text-align: right;
    }
}
</style>
